// extracted by mini-css-extract-plugin
module.exports = {"dialogs":"Dialogs_dialogs__8fEhH","empty":"Dialogs_empty__1Frcy"};